import React, { ReactNode } from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';

interface Props {
  key?: string;
  data: {
    subtitle: string;
    value: string | number | ReactNode;
  };
  isItem?: boolean;
  className?: string;
  titleClassName?: string;
  valueClassName?: string;
}

function SingleContent({ data: { subtitle, value }, isItem = false, key, className, titleClassName, valueClassName }: Props) {
  return (
    <div
      key={key}
      className={cx(
        styles.gridRow,
        {
          'm-bottom-5': isItem,
          [styles.dropdown]: !isItem,
          [styles.small]: !isItem
        },
        className
      )}
    >
      <h2 className={`${styles.subtitle} ${titleClassName}`}>{subtitle}</h2>
      <h2 className={`${valueClassName} ${styles.value}`}>{value || '-'}</h2>
    </div>
  );
}

export default SingleContent;
